import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineGrayCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <circle cx={9} cy={9} r={8} stroke="#CBCBCB" strokeWidth={2} />
  </svg>
);
export default SvgStreamlineGrayCircle;
